'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const ScrollToTop: React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Scroll to top when pathname changes, but not when there's a hash
    // (the browser handles scrolling to the hash target natively)
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};
